/**
 * Deze klasse zorgt voor het tonen van een audio entry
 *
 * @history
 * 26 juli 2023
 * Basis implementatie
 *
 */
import React from "react";

export class LogAudioEntry extends React.Component {
    constructor(props) {
        super(props);
    }

    nl2br (str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
    getMimeType(p_audio_kind)
    {
        switch (p_audio_kind)
        {
            case "webm":
                return "video/webm";
                break;

            default:
                return "audio/mpeg";
        }
    }

    render() {
        return (
            <div className={"logger__entry__wrapper"}>
                {this.props.log.title != "" &&
                    (
                        <h3>{this.props.log.title}</h3>
                    )}

                <audio controls>
                    <source src={this.props.log.audio_url} type={this.getMimeType(this.props.log.audio_kind)}/>
                </audio>

                {this.props.log.data != "" && (
                    <p dangerouslySetInnerHTML={{__html:this.nl2br(this.props.log.data)}}></p>
                )}
                <a href="javascript:void(0)"  onClick={() => this.props.edit_callback(this.props.log_index, "image")} className="logger_button"><img src={"/logger/assets/svgs/ui/pencil_white.svg"} className={"ui_icon"}/></a>
                <a href="javascript:void(0)"  onClick={() => this.props.delete_callback(this.props.log_index)} className="logger_button"><img src={"/logger/assets/svgs/ui/trash_white.svg"} className={"ui_icon"}/></a>
                <br/>

            </div>

        );
    }

}
